import { useState, useEffect } from "react";
import { getSessionDetails } from "../../../../Service/engagement";
import {
  UserEngagement,
  CommonImages,
  DashboardImages,
} from "../../../../reusableUI/images";
import CommonCard from "../../../../reusableUI/CommonCardUi";
import SmallCard from "../../../../reusableUI/smallCard";
import CommonDropdown from "../../../../reusableUI/dropdown";
import ErrorBarChart from "../../../../Charts/frequencyChart";
import UserChart from "../../../../Charts/userGraph";
import ActiveUsersChart from "../../../../Charts/activeUsers";
import SessionChart from "../../../../Charts/sessionChart";
import UserGender from "../../../../Charts/userGender";
import GeneralRole from "../../../../Charts/userByRole";
import Loader from "../../../../reusableUI/loader";

// import CountryList from "../../reusableUI/countryList";
// import IndiaFlag from "../../assets/common/IN.png";
// import CountryList2 from "../../reusableUI/countryList2";
// import UsFlag from "../../assets/common/US.png";

const Engagement = () => {
  const [card, setCard] = useState("1");
  const [loading, setLoading] = useState(true);
  const [sessionList, setSessionList] = useState([]);
  const [nurseList, setNurseList] = useState([]);
  const [physioList, setPhysioList] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [selectedValue, setSelectedValue] = useState("Over All");
  const [sessionNurseList, setSessionNurseList] = useState([]);
  const [sessionPatientList, setSessionPatientList] = useState([]);
  const [sessionPhysioList, setSessionPhysioList] = useState([]);

  useEffect(() => {
    getSessionList();
  }, [selectedValue]);

  const getSessionList = async () => {
    try {
      const result = await getSessionDetails(selectedValue);
      if (!result.error) {
        setLoading(false);
        setSessionList(result.data);

        const activeUsers = result?.data?.users?.activeUsers;
        if (Array.isArray(activeUsers)) {
          setNurseList(activeUsers.filter((user) => user.role === "nurse"));
          setPatientList(activeUsers.filter((user) => user.role === "patient"));
          setPhysioList(
            activeUsers.filter((user) => user.role === "physiotherapist")
          );
        }

        const sessionUsers = result?.data?.sessions;
        if (Array.isArray(sessionUsers)) {
          setSessionNurseList(
            sessionUsers.filter((user) => user.role === "nurse")
          );
          setSessionPatientList(
            sessionUsers.filter((user) => user.role === "patient")
          );
          setSessionPhysioList(
            sessionUsers.filter((user) => user.role === "physiotherapist")
          );
        }
      }
    } catch (error) {
      console.error("Failed to fetch session details.", error);
    }
  };

  const handleDropdownChange = (event) => setSelectedValue(event.target.value);

  const options = [
    { label: "Over All", value: "Over All" },
    { label: "Today", value: "Today" },
    { label: "Last 7 days", value: "Last 7 days" },
    { label: "Last 30 days", value: "Last 30 days" },
  ];
  const onClick = (c) => {
    setCard(c);
  };

  return (
    <>
      {loading ? (
        <div>
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="overflow-y-auto bg-[#F3F6F5] h-[90vh] mb-20 mt-0 max-w-screen overflow-x-hidden ">
          <div className="flex justify-end items-center pr-4 pt-2">
            <CommonDropdown
              options={options}
              value={selectedValue}
              onChange={handleDropdownChange}
            />
          </div>
          <div className=" flex flex-row flex-wrap justify-center items-center w-[100%] gap-3 ">
            <CommonCard
              title={"Session Length"}
              image={UserEngagement.session}
              image1={CommonImages.Up}
              count={sessionList?.averageSession}
              text={"Average duration of user sessions"}
              onClick={() => onClick("1")}
              page={card}
              id="1"
              user={"engagement"}
              size="default"
            />
            <CommonCard
              title={"Active Users"}
              image={CommonImages.active}
              count={sessionList?.users?.activeUsers.length}
              text={
                sessionList?.users?.activeUsers.length +
                " active users out of " +
                sessionList?.users?.totalUser +
                " users"
              }
              onClick={() => onClick("2")}
              page={card}
              id="2"
              user={"engagement"}
              progress={sessionList?.users?.percentage}
              size="default"
            />
            <CommonCard
              title={"Session Frequency"}
              image={UserEngagement.freqency}
              image1={UserEngagement.down1}
              count={sessionList?.sessionFrequency}
              text={"Average number of sessions per user"}
              onClick={() => onClick("3")}
              page={card}
              id="3"
              user={"engagement"}
              size="default"
            />
          </div>

          {card === "1" && (
            <div className=" h-screen ">
              <div className="bg-[#F3F6F5] ">
                <div className="bg-white mb-1 rounded-2xl shadow-md m-2">
                  <div className="flex justify-between items-center m-2">
                    <p className="text-[14px] ml-5 p-3 font-semibold">
                      Total Duration
                    </p>
                  </div>
                  <div className="border-b border-[#D7E4EB] mb-4 mt-[-10px]"></div>
                  <div className="text-center mb-2">
                    <p className="text-2xl font-bold">
                      {sessionList?.totalDuration || "0 sec"}
                    </p>
                    <p className="text-[14px] ">Total session length</p>
                  </div>
                  <div className="flex justify-center mb-4"></div>
                  <div className="flex justify-around m-4">
                    <SmallCard
                      image1={UserEngagement.greenArrow}
                      status={"Maximum Duration"}
                      count={sessionList?.maxSessionDuration || "0 sec"}
                      image2={CommonImages.Up}
                    />
                    <SmallCard
                      image1={UserEngagement.brownArrow}
                      status={"Average Duration"}
                      count={sessionList?.averageSession || "0 sec"}
                      image2={CommonImages.Up}
                    />
                  </div>
                </div>
              </div>
              <div className="bg-white  mb-4 rounded-2xl shadow-md m-2 mt-[-5px] ">
                <div className="flex justify-between items-start">
                  <p className="text-[14px] p-3 ml-3 font-semibold">
                    Sessions By Users
                  </p>
                </div>
                <div className="border-b border-[#D7E4EB] mb-1 "></div>
                <div className="p-2">
                  {/* <UserChart data={sessionList?.sessions} /> */}

                  <div className="">
                    <SessionChart
                      values={selectedValue}
                      nurseData={sessionNurseList}
                      patientData={sessionPatientList}
                      physioData={sessionPhysioList}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-row items-center pb-6 w-full ml-2 flex-wrap">
                <div className="w-full min-[1100px]:w-1/2 pr-2 ">
                  <GeneralRole
                    timePeriod={selectedValue}
                    nurseData={sessionNurseList}
                    patientData={sessionPatientList}
                    physioData={sessionPhysioList}
                  />
                </div>

                <div className="w-full min-[1100px]:w-1/2 pr-4">
                  <UserGender
                    users={[
                      ...sessionNurseList,
                      ...sessionPatientList,
                      ...sessionPhysioList,
                    ]}
                    value={selectedValue}
                  />
                </div>
              </div>
              {/* <div className="mt-3">
                <CountryList countries={countries} title={"Sessions length by Countries"} />
              </div> */}
            </div>
          )}

          {card === "2" && (
            <div className=" h-screen ">
              <div className="bg-white mb-3 rounded-2xl shadow-md m-2">
                <div className="flex justify-between items-center m-2">
                  <p className="text-[14px] ml-5 p-3 font-semibold">
                    Active Users
                  </p>
                </div>
                <div className="border-b border-[#D7E4EB] mb-4 mt-[-10px]"></div>

                <div className="p-2">
                  <ActiveUsersChart
                    values={selectedValue}
                    nurseData={nurseList}
                    patientData={patientList}
                  />
                </div>
              </div>

              <div className="flex flex-row items-center mb-[60px] w-full ml-2 flex-wrap ">
                <div className="w-full min-[1100px]:w-1/2 pr-2">
                  <GeneralRole
                    values={selectedValue}
                    nurseData={nurseList}
                    patientData={patientList}
                    physioData={physioList}
                  />
                </div>
                <div className="w-full min-[1100px]:w-1/2 pr-4 ">
                  <UserGender
                    users={[...nurseList, ...patientList, ...physioList]}
                  />
                </div>
              </div>

              {/* <CountryList2 countries={countries2} title={"Active Users Countries"} /> */}
            </div>
          )}

          {card === "3" && (
            <div className=" h-screen ">
              <div className="bg-white  mb-3 rounded-2xl shadow-md m-2 ">
                <div className="flex justify-between items-center m-2">
                  <p className="text-[14px] p-3 ml-1 font-semibold mt-[-5px]">
                    Session frequency Count
                  </p>
                </div>
                <div className="border-b border-[#D7E4EB] mb-1 mt-[-10px]"></div>
                <div className="m-2 p-4 pb-3">
                  <ErrorBarChart
                    values={selectedValue}
                    users={[
                      ...sessionNurseList,
                      ...sessionPatientList,
                      ...sessionPhysioList,
                    ]}
                  />
                </div>
              </div>

              {/* <Age registrations={usersAgeData} /> */}

              {/* <CountryList countries={countries} title={"Sessions frequency by Countries"} /> */}

              <div className="flex flex-row items-center mb-[60px] w-full ml-2 flex-wrap ">
                <div className="w-full min-[1100px]:w-1/2 pr-2">
                  <GeneralRole
                    values={selectedValue}
                    nurseData={sessionNurseList}
                    patientData={sessionPatientList}
                    physioData={sessionPhysioList}
                  />
                </div>
                <div className="w-full min-[1100px]:w-1/2 pr-4">
                  <UserGender
                    users={[
                      ...sessionNurseList,
                      ...sessionPatientList,
                      ...sessionPhysioList,
                    ]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Engagement;
